import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { BrowserModule } from "@angular/platform-browser";
import { TranslateModule } from "@ngx-translate/core";
import { ComumModule } from "./../../../shared/comum.module";
import { translateLoaderNBS } from "./../../../shared/translate-loader/translateLoader";
import { BonificacaoCadastroComponent } from "./bonificacao-cadastro/bonificacao-cadastro.component";
import { BonificacaoFiltroComponent } from "./bonificacao-filtro/bonificacao-filtro.component";
import { BonificacaoListaComponent } from "./bonificacao-lista/bonificacao-lista.component";
import { BonificacaoService } from "./bonificacao-service/bonificacao.service";
import { BonificacaoComponent } from "./bonificacao.component";
import { FileUploadModule } from './../../../shared/fileupload/fileupload';

@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    TranslateModule.forRoot(translateLoaderNBS),
    FileUploadModule
  ],
  exports: [
    BonificacaoComponent
  ],
  declarations: [
    BonificacaoComponent,
    BonificacaoCadastroComponent,
    BonificacaoListaComponent,
    BonificacaoFiltroComponent
  ],
  providers: [
    BonificacaoService
  ]
})
export class BonificacaoModule { }
